module.exports= {
	ADULT : "ADULT",
  CHILD : "CHILD",
  INFANT : "INFANT"
}


// WEBPACK FOOTER //
// ./src/const/PassengerType.js